import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [ "input", "button" ];

  connect() {
    this.hide();
    this.buttonTarget.hidden = false;
  }

  preserveFocus(event) {
    if (document.activeElement === this.inputTarget) event.preventDefault();
  }

  toggle(event) {
    event.preventDefault();

    const input = this.inputTarget;
    const selectionStart = input.selectionStart;
    const selectionEnd = input.selectionEnd;
    const showing = input.type === "password";

    input.type = showing ? "text" : "password";
    this.updateButton();

    if (document.activeElement === input && selectionStart !== null && selectionEnd !== null) {
      input.setSelectionRange(selectionStart, selectionEnd);
    }
  }

  hide() {
    this.inputTarget.type = "password";
    this.updateButton();
  }

  updateButton() {
    const showing = this.inputTarget.type === "text";
    const action = showing ? "Hide" : "Show";

    this.buttonTarget.textContent = action;
    this.buttonTarget.setAttribute("aria-label", `${action} ${this.element.dataset.passwordToggleLabel}`);
    this.buttonTarget.removeAttribute("aria-pressed");
  }
}
